/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    sourceOrderId?: number;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    goodsId?: number;
    /**
     * 查询时的历史商品结构签名，用于提交时复核
     * @type {string}
     * @memberof Item
     */
    structureSignature?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    marketBarcode?: string;
    /**
     * 合并后的全部来源商品ID，仅用于核对同会员/仓库/构成及来源追溯。
     * @type {Array<number>}
     * @memberof Item
     */
    sourceGoodsIds?: Array<number>;
    /**
     * 返送数量，正整数；合包按套数，不限制历史出库数量
     * @type {number}
     * @memberof Item
     */
    quantity?: number;
}

/**
 * Check if a given object implements the Item interface.
 */
export function instanceOfItem(value: object): value is Item {
    return true;
}

export function ItemFromJSON(json: any): Item {
    return ItemFromJSONTyped(json, false);
}

export function ItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): Item {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceOrderId': json['sourceOrderId'] == null ? undefined : json['sourceOrderId'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'structureSignature': json['structureSignature'] == null ? undefined : json['structureSignature'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'sourceGoodsIds': json['sourceGoodsIds'] == null ? undefined : json['sourceGoodsIds'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function ItemToJSON(json: any): Item {
    return ItemToJSONTyped(json, false);
}

export function ItemToJSONTyped(value?: Item | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceOrderId': value['sourceOrderId'],
        'goodsId': value['goodsId'],
        'structureSignature': value['structureSignature'],
        'marketBarcode': value['marketBarcode'],
        'sourceGoodsIds': value['sourceGoodsIds'],
        'quantity': value['quantity'],
    };
}

